import { useAPI, useAsyncHandler } from '~/hooks/common';

import { API_ENDPOINT } from '~/constants';

import type { TypeErrorResponseData } from '~/types/common.types';
import type { TypeGetTemplatesDownloadUrlResponse } from '~/types/delivery-agency.types';

const useGetTemplatesDownloadUrl = () => {
  const { runAsync } = useAsyncHandler();

  const getTemplatesDownloadUrl = useAPI<unknown, TypeGetTemplatesDownloadUrlResponse>({
    endpoint: API_ENDPOINT.DELIVERY_AGENCY.GET_TEMPLATES_DOWNLOAD_URL,
    method: 'get',
  });

  const requestTemplatesDownloadUrl = ({
    pathParams,
    onSuccess,
    onError,
  }: {
    pathParams: { type: string };
    onSuccess?: (url: TypeGetTemplatesDownloadUrlResponse['data']) => void;
    onError?: (error: TypeErrorResponseData['error']) => void;
  }) =>
    runAsync(() => getTemplatesDownloadUrl({ pathParams: `?type=${pathParams.type}` }), {
      onSuccess: ({ data }) => onSuccess?.(data),
      onError: (error: TypeErrorResponseData['error']) => onError?.(error),
    });
  return { requestTemplatesDownloadUrl };
};

export default useGetTemplatesDownloadUrl;
